export default __webpack_public_path__ + "static/salesforce-partner-58828c13c9cd88a568f761395e160188.png";